import React from 'react';
import styled from 'styled-components';

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  width: 100%;

  padding: 0;

  button {
    min-width: 25px;
    height: 44px;
    padding: 0;

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: rgba(194, 196, 200, 1);

    background-color: transparent;
    border: none;

    cursor: pointer;

    &.cancel {
      color: #414b56;
    }

    &.search {
      color: rgba(194, 196, 200, 1);
    }
  }
`;

const InputBox = styled.div<{ $isSearched: boolean; $maxWidth: string }>`
  display: flex;
  align-items: center;
  gap: 8px;

  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth};
  height: 44px;
  padding: 12px;

  border: 1px solid;
  border-radius: 12px;

  ${({ $isSearched }) =>
    $isSearched
      ? `
      background-color: #F7F7F8;
      border-color: rgba(194, 196, 200, 1);
      `
      : `
      background-color: transparent;
      border-color: #DBDCDF;
    `}

  input {
    width: 100%;
    border: none;
    outline: none;

    font-weight: 400;
    font-size: 14px;

    background-color: inherit;

    &::placeholder {
      font-weight: 400;
      font-size: 14px;

      color: rgba(152, 155, 162, 1);
    }
  }
`;

interface Props {
  searchKeyword: string;
  placeholder: string;
  keywordHandler: (value: string) => void;
  handleSearch: (keyword?: string) => void;
  isSearched: boolean;
  maxWidth?: string;
}

function SearchInput({
  searchKeyword,
  placeholder,
  keywordHandler,
  handleSearch,
  isSearched,
  maxWidth = '100%',
}: Props) {
  const onClickSearchButton = () => {
    if (isSearched) {
      keywordHandler('');
      handleSearch('');
      return;
    }

    handleSearch();
  };

  return (
    <InputContainer>
      <InputBox $isSearched={isSearched} $maxWidth={maxWidth}>
        <input
          placeholder={placeholder}
          value={searchKeyword || ''}
          onChange={e => keywordHandler(e.currentTarget?.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
        />
      </InputBox>

      <button
        className={isSearched ? 'cancel' : 'search'}
        onClick={onClickSearchButton}
      >
        {isSearched ? '취소' : '검색'}
      </button>
    </InputContainer>
  );
}

export default SearchInput;
